/* eslint-disable indent */
import { observable, action, runInAction } from 'mobx';
import { isEmpty, cloneDeep } from 'lodash';

const moSider = observable({
  isExpand: false,
  activeName: '行业对比',
  siderTop: 420,
});

const siderInit = action(() => {});

const toggleExpand = action((val: boolean) => {
  moSider.isExpand = val;
});

const changeTop = action((val: number) => {
  moSider.siderTop = val;
});

const changeModule = action((val: string) => {
  const effect02Dis = document.getElementById('effect01')?.getBoundingClientRect().height || 660;
  const dis02 = effect02Dis + 400;
  const effect03Dis = document.getElementById('effect02')?.getBoundingClientRect().height || 600;
  const dis03 = effect03Dis + dis02 + 20;
  const effect04Dis = document.getElementById('effect03')?.getBoundingClientRect().height || 600;
  const dis04 = effect04Dis + dis03 + 20;
  const effect05Dis = document.getElementById('effect04')?.getBoundingClientRect().height || 600;
  const dis05 = effect05Dis + dis04 + 20;
  const effect06Dis = document.getElementById('effect05')?.getBoundingClientRect().height || 600;
  const dis06 = effect06Dis + dis05 + 20;
  const effect07Dis = document.getElementById('effect06')?.getBoundingClientRect().height || 600;
  const dis07 = effect07Dis + dis06 + 20;
  const effect08Dis = document.getElementById('effect07')?.getBoundingClientRect().height || 600;
  const dis08 = effect08Dis + dis07 + 20;
  const effect09Dis = document.getElementById('effect08')?.getBoundingClientRect().height || 600;
  const dis09 = effect09Dis + dis08 + 80;
  const effect10Dis = document.getElementById('effect09')?.getBoundingClientRect().height || 600;
  const dis10 = effect10Dis + dis09 + 20;
  const effect11Dis = document.getElementById('effect10')?.getBoundingClientRect().height || 600;
  const dis11 = effect11Dis + dis10 + 20;
  const effect12Dis = document.getElementById('effect11')?.getBoundingClientRect().height || 600;
  const dis12 = effect12Dis + dis11 + 80;
  const effect13Dis = document.getElementById('effect12')?.getBoundingClientRect().height || 600;
  const dis13 = effect13Dis + dis12 + 20;
  const effect14Dis = document.getElementById('effect13')?.getBoundingClientRect().height || 600;
  const dis14 = effect14Dis + dis13 + 20;
  const effect15Dis = document.getElementById('effect14')?.getBoundingClientRect().height || 600;
  const dis15 = effect15Dis + dis14 + 20;
  const effect16Dis = document.getElementById('effect15')?.getBoundingClientRect().height || 600;
  const dis16 = effect16Dis + dis15 + 80;
  // console.log('切换左侧菜单栏 -- ', val);

  switch (val) {
    case '人效行业对比':
      window.scrollTo(0, 330);
      break;
    case '人效时间趋势':
      window.scrollTo(0, dis02);
      break;
    case '人效变化率分布':
      window.scrollTo(0, dis03);
      break;
    case '人力资本回报分析':
      window.scrollTo(0, dis04);
      break;
    case '员工规模与元均效能':
      window.scrollTo(0, dis05);
      break;
    case 'Top10公司列表':
      window.scrollTo(0, dis06);
      break;
    case '招聘量与营收':
      window.scrollTo(0, dis07);
      break;
    case '薪酬成本行业对比':
      window.scrollTo(0, dis08);
      break;
    case '薪酬成本时间趋势':
      window.scrollTo(0, dis09);
      break;
    case '费用中的薪酬占比':
      window.scrollTo(0, dis10);
      break;
    case '人员配置行业对比':
      window.scrollTo(0, dis11);
      break;
    case '人员配置时间趋势':
      window.scrollTo(0, dis12);
      break;
    case '人员配置变化率分布':
      window.scrollTo(0, dis13);
      break;
    case '员工构成时间趋势':
      window.scrollTo(0, dis14);
      break;
    case '支持效能行业对比':
      window.scrollTo(0, dis15);
      break;
    case '支持效能时间趋势':
      window.scrollTo(0, dis16);
      break;
  }
  moSider.activeName = val;
});

export default moSider;
export {
  siderInit, toggleExpand, changeTop, changeModule,
};
